"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledContainer = exports.StyleFooter = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tablestyle__StyledWrapper",
  componentId: "sc-veo8gb-0"
})(["position:relative;width:", ";.expansion-cell{box-sizing:border-box;padding-left:50px;width:96px !important;height:69px !important;}:before{content:", ";position:absolute;display:inline-flex;align-items:center;background:transparent;left:2px;bottom:calc(100% + 16px);font-size:14px;line-height:16px;color:", ";z-index:111;", ";}"], ({
  width
}) => width ? width : '100%', ({
  caption
}) => caption && `'${caption}'`, _shared.theme.palette.brand.primary.charcoal, ({
  hideCaption
}) => hideCaption && `display:none`);

exports.StyledWrapper = StyledWrapper;

const StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "Tablestyle__StyledContainer",
  componentId: "sc-veo8gb-1"
})(["width:", ";border-top-left-radius:", ";border-top-right-radius:", ";background:", ";padding-bottom:", ";overflow-x:auto;scroll-behavior:smooth;::-webkit-scrollbar{padding-left:48px;height:3px;}::-webkit-scrollbar-track{background:", ";border-radius:4px;}::-webkit-scrollbar-thumb{background:", ";border-radius:4px;}::-webkit-scrollbar-button{display:block;width:24px;}::-webkit-scrollbar-button:decrement:start{background-color:", ";}::-webkit-scrollbar-button:increment:start{background-color:", ";}::-webkit-scrollbar-button:decrement:end{background-color:", ";}::-webkit-scrollbar-button:increment:end{background-color:", ";}"], ({
  width
}) => width, ({
  borderRadius
}) => borderRadius ? borderRadius : '0px', ({
  borderRadius
}) => borderRadius ? borderRadius : '0px', _shared.theme.palette.brand.primary.white, ({
  width
}) => width === '100%' ? '0px' : '24px', _shared.theme.palette.ui.neutral.grey4, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.white);

exports.StyledContainer = StyledContainer;

const StyleFooter = _styledComponents.default.div.withConfig({
  displayName: "Tablestyle__StyleFooter",
  componentId: "sc-veo8gb-2"
})(["box-sizing:border-box;display:flex;justify-content:center;align-items:center;width:100%;padding:25px 0;border-bottom-left-radius:", ";border-bottom-right-radius:", ";background:", ";"], ({
  borderRadius
}) => borderRadius ? borderRadius : '0px', ({
  borderRadius
}) => borderRadius ? borderRadius : '0px', _shared.theme.palette.brand.primary.white);

exports.StyleFooter = StyleFooter;